import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { blogPosts } from '../mock';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

const Blog = () => {
  return (
    <div className="min-h-screen bg-[#000000] pt-20 sm:pt-24">
      <SEO 
        title="Blog - Publishing Tips & Insights"
        description="Read expert publishing advice, writing tips, and industry insights. Stay updated with the latest trends in book publishing, marketing strategies, and author success stories."
        keywords="book publishing blog, writing tips, author advice, book marketing, publishing industry news, self publishing tips, book promotion, manuscript editing tips"
        url="/blog"
      />
      {/* Hero Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-b from-[#1a1a1a] to-[#000000]">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#F4D03F] mb-4 sm:mb-6 uppercase">
              LATEST FROM OUR BLOG
            </h1>
            <p className="text-lg sm:text-xl text-[#dfddd6] leading-relaxed">
              Insights, tips, and stories from the world of publishing. Stay updated with industry trends and expert advice.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-16 sm:py-20 md:py-24 bg-[#000000]">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            {blogPosts.map((post) => (
              <Card key={post.id} className="bg-[#302f2c] border-[#3f4816] overflow-hidden hover:border-[#F4D03F] transition-all duration-300 group">
                <div className="aspect-video overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <CardHeader className="pb-4 p-4 sm:p-6">
                  <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                    <span className="text-[#F4D03F] text-[10px] sm:text-xs uppercase font-semibold">{post.category}</span>
                    <span className="text-[#888680] text-[10px] sm:text-xs">{post.date}</span>
                  </div>
                  <CardTitle className="text-[#dfddd6] text-lg sm:text-xl group-hover:text-[#F4D03F] transition-colors leading-tight">
                    {post.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 p-4 sm:p-6">
                  <Link to={`/blog/${post.id}`}>
                    <Button className="btn-secondary w-full group text-sm sm:text-base">
                      Read More
                      <ArrowRight size={16} className="ml-2 transition-transform duration-200 group-hover:translate-x-1" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16 sm:py-20 bg-[#302f2c]">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#F4D03F] mb-4 uppercase">Stay Updated</h2>
            <p className="text-[#888680] mb-6 sm:mb-8 text-sm sm:text-base">
              Subscribe to our newsletter for the latest publishing tips, industry news, and exclusive offers.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 h-11 sm:h-12 px-4 rounded-lg bg-[#000000] border border-[#3f4816] text-[#dfddd6] placeholder:text-[#888680] focus:border-[#F4D03F] outline-none text-sm sm:text-base"
              />
              <Button className="bg-[#F4D03F] text-black hover:bg-[#F8D26B] font-bold px-6 h-11 sm:h-12 text-sm sm:text-base">
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;